export default __webpack_public_path__ + "static/media/defencepot.330648ed.PNG";